import SkeletonComponent from '@components/skeleton';

const CardTitleSkeleton = () => {
    return <SkeletonComponent width="100%" maxWidth={'240px'} height={'20px'} />;
};

export default CardTitleSkeleton;
